import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/fax-numbers',
    getDefault(){
        return {
            id : undefined,
            user_id : undefined,
            number : undefined,
            vertical_service_code : undefined,
            fax_channel_id : undefined,
            zone : undefined,
            incoming : false,
            outgoing : false,
            state : undefined,
            created_at : undefined,
            updated_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params category
     * @return Request Promise
     **/
    async create(model) {
        return await Client.post(`${this.url}`, model);
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async update(model) {
        return await Client.post(`${this.url}/${model.id}`, model);
    },
    /**
     * @params accountingReceipt
     * @return Request Promise
     **/
    async delete(id) {
        return await Client.post(`${this.url}` + '/' + id + '/delete');
    },
}

export default FaxesService